import React from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../utils/localStorage";

const { innerWidth: width, innerHeight: height } = window;

const TabMenu = ({ storeId }) => {
  const navigate = useNavigate();
  const { userProfileRole } = getUserData();
  const userRole = userProfileRole;
  return (
    <div
      className="z-2"
      style={{
        flex: 1,
        backgroundColor: "#fff",
        boxShadow: "10px 0px 8px 0 rgba(0,0,0,0.2)",
        position: "fixed",
        width: "100%",
        bottom: 0,
        height: height < 600 ? 60 : 70,
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center",
      }}
    >
      <div className="cursor-pointer " onClick={() => navigate("/")}>
        <div className="flex justify-content-center align-items-center h-3rem">
          <img
            style={{ width: height < 600 ? "20px" : "25px" }}
            src="/Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Home_Selected.png"
            alt="logo"
          />
        </div>
        <p>Home</p>
      </div>
      <div className="cursor-pointer" onClick={() => navigate("/Orders")}>
        <div className="flex justify-content-center align-items-center h-3rem">
          <img
            style={{ width: height < 600 ? "37px" : "50px" }}
            src="/Laundy_App_Icons_Gifs/Customer_Info_GIFs/Running_Order.gif"
            alt="logo"
          />
        </div>
        <p>Orders</p>
      </div>
      <div
        className="cursor-pointer"
        onClick={() => {
          if (userRole === "BY_FRANCHISE_ADMIN") {
            navigate("/full-dashboard", {
              state: { source: "nav" },
            });
          } else if (userRole === "BY_SUPPORT_ADMIN") {
            navigate("/PickupJobForm", {
              state: { source: "nav" },
            });
          } else if (userRole === "BY_ADMIN") {
            if (storeId ?? "") {
              navigate("/searchCustomer", {
                state: {
                  storeId: storeId,
                }
              })
            } else {
              console.log("No Navigation")
            }
          } else {
            navigate("/searchCustomer", {
              state: { source: "nav" },
            })
          }

        }}
      >
        <div className="flex justify-content-center align-items-center h-3rem">
          <img
            style={{ width: height < 600 ? "50px" : "60px" }}
            src="/Laundy_App_Icons_Gifs/Customer_Info_GIFs/Book_New_Order.gif"
            alt="logo"
          />
        </div>
        <p>
          {userRole === "BY_ADMIN" ||
            userRole === "BY_SUB_ADMIN_USER" ||
            userRole === "BY_FRANCHISE_ADMIN" ||
            userRole === "BY_SUPPORT_ADMIN"
            ? " "
            : "Quick Book"}
        </p>
      </div>
      <div className="cursor-pointer"
        onClick={() => {
          if (userRole === "BY_STORE") {
            navigate("/PickupJob", {
              state: { source: "nav" },
            });
          } else if (userRole === "BY_SUPPORT_ADMIN") {
            navigate("/RiderJobs", {
              state: { source: "nav" },
            });
          } else {
            navigate("/RiderJobs", {
              state: { source: "nav" },
            })
          }

        }}
      >
        <div className="flex justify-content-center align-items-center h-3rem">
          <img
            style={{ width: height < 600 ? "40px" : "50px" }}
            src="/Laundy_App_Icons_Gifs/Customer_Info_GIFs/Pickup_Request.gif"
            alt="logo"
          />
        </div>
        <p>
          {userRole === "BY_ADMIN" ||
            userRole === "BY_SUB_ADMIN_USER" ||
            userRole === "BY_FRANCHISE_ADMIN" ||
            userRole === "BY_SUPPORT_ADMIN"
            ? "Rider Jobs"
            : "Pick Up"}
        </p>
      </div>
      {userRole !== "BY_SUPPORT_ADMIN" && <div className="cursor-pointer" onClick={() => navigate("/Setting")}>
        <div className="flex justify-content-center align-items-center h-3rem">
          <img
            style={{ width: height < 600 ? "25px" : "30px" }}
            src="/Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Settings.png"
            alt="logo"
          />
        </div>
        <p>Setting</p>
      </div>}
    </div>
  );
};

export default TabMenu;
